var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 6C12.0523 6 12.5 6.44772 12.5 7V11.4444C12.5 11.9967 12.0523 12.4444 11.5 12.4444C10.9477 12.4444 10.5 11.9967 10.5 11.4444V7C10.5 6.44772 10.9477 6 11.5 6Z",
    fill: "#FF6536"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 13.1111C12.0523 13.1111 12.5 13.5588 12.5 14.1111V15C12.5 15.5523 12.0523 16 11.5 16C10.9477 16 10.5 15.5523 10.5 15V14.1111C10.5 13.5588 10.9477 13.1111 11.5 13.1111Z",
    fill: "#FF6536"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66589 16.1321C2.21151 16.9198 2.766 18 3.85709 18H19.3931C20.4842 18 21.0387 16.9198 20.5843 16.1321L12.8163 2.66559C12.3044 1.77814 10.9458 1.77814 10.4339 2.66559L2.66589 16.1321ZM3.85709 20C1.35902 20 -0.355211 17.3668 0.933458 15.1327L8.70148 1.66625C9.98301 -0.555411 13.2672 -0.555421 14.5487 1.66625L22.3167 15.1327C23.6054 17.3668 21.8912 20 19.3931 20H3.85709Z",
    fill: "#FF6536"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoid);
export default __webpack_public_path__ + "static/media/void.6bc10dd99b8fadfc6b76ae5400950686.svg";
export { ForwardRef as ReactComponent };